<template>
    <div class="Media">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Media__container">
                <video ref="stream" autoplay playsinline></video>


                <video class="Media__movie" ref="movie" playsinline>
                    <source src="/static/foreground_caps_en.mov" type="video/mp4"> 
                    <!-- <source src="https://meneath-v2.dpt.media/static/alpha.webm" type="video/mp4">  -->
                    <!-- <source src="/static/overlay.webm" type="video/webm">  -->
                </video>



                <div class="Media__canvas">
                    <canvas id="output-canvas" width="1080" height="608"></canvas>
                </div>

                <div class="Media__border"> 
                    <img :src="require('@/commons/images/target.png')">
                </div> 

                <div class="Media__button" @click="onClick()" v-if="sync">Sync</div>
               

            </div>
        </transition>

        <div class="Media__stopped"  v-if="stopped">Projection stopped!</div>

    </div>
</template>

<script>

import { Howl, Howler } from 'howler'

export default {

    name: 'Media',
    data: ()=>({
        is_playing: false,
        sync: true,
        ready: false,
        stopped: false,
        delay: 1,
        loop: 0
    }), 


    computed: {
        sync_time() { return this.$store.getters['socket/sync_time'] },
        start_movie() { return this.$store.getters['socket/start_movie'] },
        user_leave() { return this.$store.getters['socket/user_leave'] },
    },

    watch: {
        start_movie(nw, od) {
            console.log(nw);
            if(nw == true)
                this.isStarted()
        },
        user_leave(nw, od){
            this.stopped = true
            this.$refs.movie.pause()
            this.$refs.movie.removeEventListener('play', this.computeFrame )
            this.$id = this.$sound.pause()
        },
        sync_time(nw, od) {

            // console.log(Date.now()-nw.utc);
            // 66.534685
            // const movie_cue = Math.floor((this.$refs.movie.currentTime * 10000))/10000

            if(this.loop == 0) {
               
                const utc = Date.now()-nw.utc
                const adj = utc/1000
                const cue = nw.time + adj + .2  
  
                this.$refs.movie.currentTime = cue
                this.$sound.seek(cue, this.$id)
            }

            this.loop += 1
            if(this.loop ==10) 
                this.loop = 0


            // const diff = Math.abs(nw.time - this.$refs.movie.currentTime)

            // // console.log(diff + ' == ');

            // const cue = nw.time + .2    
            // if(diff > 1) {
            //     this.$refs.movie.currentTime = cue
            //     this.$sound.seek(cue, this.$id)
            // }

            
        },
    },


    beforeDestroy() {
        this.$socket.emit('userLeaveRoom', this.$room)   
    },
    created(){
        this.$room = this.$route.params.room ? this.$route.params.room : 350
        console.log('Media --- ');
    },

    mounted : async function (){

        window.addEventListener('resize', this.onResize)
        window.addEventListener('orientationchange', this.onResize)
        const constraints = window.constraints = { audio: false, video: { facingMode: "environment" } }
        try {
            
            const stream = await navigator.mediaDevices.getUserMedia(constraints)
            this.handleSuccess(stream);
            this.init()


            // e.target.disabled = true;

        } catch (e) {
            // handleError(e);
        }
    

    },

    methods: {
        onClick() {
            this.sync = false
            this.$socket.emit('startProjection', { room: this.$room, used: true })
        },


        isStarted() {

            console.log('isStarted');

            this.$refs.movie.play()
            // this.$refs.movie.addEventListener('play', this.computeFrame )
            // window.requestAnimationFrame(this.computeFrame)


            this.$refs.movie.addEventListener('play', () => {
                this.width = this.$refs.movie.videoWidth
                this.height = this.$refs.movie.videoHeight 
                this.timerCallback()
            }, false);



            this.$id = this.$sound.play()
            this.$sound.seek(0, this.$id)
        },


        enter(done) {
            done()
        },
        leave(done) {
            done()
        },  
        handleSuccess(stream) {
            const video = this.$refs.stream
            const videoTracks = stream.getVideoTracks()
            video.srcObject = stream
        },
        init() {
            this.$c1 = document.getElementById('output-canvas')
            this.$ctx1 = this.$c1.getContext('2d')
            this.$c_tmp = document.createElement('canvas');
            this.$c_tmp.setAttribute('width', 1080)
            this.$c_tmp.setAttribute('height', 608)
            this.$ctx_tmp = this.$c_tmp.getContext('2d');
            this.onResize()

            this.$sound = new Howl({
                src: [require('@/commons/sound/sound.mp3')],
                // autoplay: true,
                volume: 1
            })
            TweenMax.delayedCall(this.delay, ()=>{
                this.$refs.movie.muted = true
                // this.$id = this.$sound.play()
                if(this.$socket.connected)
                    this.$socket.emit('joinSession', this.$room, 'visitor')
            })
        },


        timerCallback() {
            if (this.$refs.movie.paused || this.$refs.movie.ended) 
              return 
            this.computeFrame()
            setTimeout(() => {
                this.timerCallback()
            }, 0)
        },





        computeFrame() {

            // if (this.$refs.movie.paused || this.$refs.movie.ended) {
            //   return;
            // }

            this.$ctx_tmp.drawImage(this.$refs.movie, 0, 0, this.width , this.height )
            let frame = this.$ctx_tmp.getImageData(0, 0, this.width , this.height )

            for (let i = 0; i < frame.data.length /4; i++) {
                let r = frame.data[i * 4 + 0]
                let g = frame.data[i * 4 + 1]
                let b = frame.data[i * 4 + 2]

                if (g > 100 && r < 112) 
                    frame.data[i * 4 + 3] = 0
            }
            this.$ctx1.putImageData(frame, 0, 0)
            // window.requestAnimationFrame(this.computeFrame)
            // setTimeout(this.computeFrame, 0)
        },
        onResize() {
            TweenMax.set('.Media__canvas', { scale: (window.innerWidth/1080)*.74 })
        },
    }
    
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

// .Media
//     overflow hidden
//     position absolute
//     width 100vw
//     height 100%
//     color white
//     background white

//     &__container
        
//         width 100%
//         height 100%
//         position relative
//         display flex 
//         justify-content center
//         align-items center

//     &__button 
//         width 80px
//         height 80px
//         border-radius 50%
//         background black
//         border 2px solid white
//         z-index 2
//         cursor pointer
//         display flex 
//         justify-content center
//         align-items center
//         position absolute
//         top 50%
//         left 50%
//         transform translate(-50%, -50%)

//     &__movie
//         overflow hidden
//         position absolute
//         top 50%
//         left 50%
//         transform translate(-50%, -50%)
//         background-color transparent
//         width 76%
//         opacity 0
//         // border 2px solid red

//     &__canvas
//         overflow hidden
//         position absolute
//         background-color transparent
//         // border 2px solid purple

//     &__border 
//         position absolute
//         width 100%
//         top 50%
//         left 50%
//         transform translate(-50%, -50%)
//         // opacity .2

//     &__stopped
//         width 100vw
//         height 100vh
//         background rgba(black, .9)
//         position absolute
//         top 0
//         left 0
//         display flex 
//         align-items center
//         justify-content center
//         z-index 5

</style>